import type { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import type * as v from 'valibot';
import type { IdentitySchema } from './schema';

export type IdentityResponse = v.InferOutput<typeof IdentitySchema>;

export const IDENTITY_QUERY: DocumentNode = gql`
  query UserIsLoggedIn {
    identity: tuCreditReport {
      creditScore: vantageScore3
      approvalOdds: vantageScore3Bucket
    }
    rawIdentity {
      data
    }
  }
`;
